import { useCallback } from "react";
import { useToken, useUser } from "@packsize/authentication";
import { FormattedMessage, useIntl } from "react-intl";

import { ReactComponent as MovedLocationIcon } from "@/assets/images/common-icons/moved-location.svg";
import { MovedLocationTemplate } from "@/components/moved-location-template/moved-location-template";
import { getSiteToken } from "@/api/identity-api";
import { companyUrl } from "@/environment";

export const UsersAndRolesMoved = () => {
	const { decodedToken } = useToken();
	const { hasAnyRole } = useUser();
	const intl = useIntl();
	const showCompanyManagementButton =
		hasAnyRole(["TenantAdmin", "ManageCompanyAccess", "AccountManager", "PacksizePartner"]) === true;

	const handleCompanyManagementClick = useCallback(async () => {
		if (decodedToken === null || decodedToken === undefined) {
			return;
		}

		const tenantId = decodedToken.tid;
		const tokenResponse = await getSiteToken(tenantId);
		const encodedToken = btoa(tokenResponse.access_token);

		window.open(
			`${companyUrl}/sites?token=${encodeURIComponent(encodedToken)}&tenantId=${encodeURIComponent(tenantId)}`,
			"_blank",
		);
	}, [decodedToken]);

	return (
		<MovedLocationTemplate
			icon={
				<MovedLocationIcon
					aria-label={intl.formatMessage({ id: "Moved location icon", defaultMessage: "Moved location icon" })}
				/>
			}
			header={<FormattedMessage id="Users and Roles Have Moved" defaultMessage="Users and Roles Have Moved" />}
			body={
				showCompanyManagementButton === true ? (
					<FormattedMessage
						id="You can access them by selecting Company Management in your profile menu"
						defaultMessage="You can access them by selecting Company Management in your profile menu"
					/>
				) : (
					<FormattedMessage
						id="Please contact your administrator for Company Management access"
						defaultMessage="Please contact your administrator for Company Management access"
					/>
				)
			}
			onActionClick={showCompanyManagementButton === true ? handleCompanyManagementClick : undefined}
			actionLabel={
				showCompanyManagementButton === true ? (
					<FormattedMessage id="Go To Company Management" defaultMessage="Go To Company Management" />
				) : undefined
			}
		/>
	);
};
